const FLOORS = { file: 180, access: 150 };

export function fitColumns(widths, room, ticked) {
  const lead = Number(ticked);
  const over = widths.reduce((sum, w) => sum + w, 0) - room;
  if (over <= 0 || room <= 0) return widths;

  const give = { [lead]: widths[lead] - FLOORS.file, [lead + 4]: widths[lead + 4] - FLOORS.access };
  const spare = Math.max(0, give[lead]) + Math.max(0, give[lead + 4]);
  if (spare === 0) return widths;

  const cut = Math.min(over, spare) / spare;
  return widths.map((w, i) => (i in give ? w - Math.ceil(Math.max(0, give[i]) * cut) : w));
}
